import {Grid2} from '@mui/material'

export const Grid = Grid2
